export default __webpack_public_path__ + "static/media/process1.0100dd2a.webp";